
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/use-case/tag-wallet",
      function () {
        return require("private-next-pages/use-case/tag-wallet.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/use-case/tag-wallet"])
      });
    }
  